/* Seravonti — cart drawer: items, quantities, recommendations. Replaces the theme minicart. */
(function () {
  const root = document.querySelector('[data-sv-cart]');
  if (!root || window.SeravontiCart) return;

  const itemsEl = root.querySelector('[data-sv-items]');
  const footEl = root.querySelector('[data-sv-foot]');
  const totalEl = root.querySelector('[data-sv-total]');
  const recsSide = root.querySelector('[data-sv-recs-side]');
  const recsStrip = root.querySelector('[data-sv-recs-strip]');
  const recsLists = root.querySelectorAll('[data-sv-recs-list]');
  const recsBase = root.dataset.recsUrl || '/recommendations/products';
  const onCartPage = /^\/cart\/?$/.test(window.location.pathname);

  let cart = null;
  let recsFor = null;
  let recs = [];
  let lastProductId = Number(root.dataset.productId) || null;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const money = (cents, currency) => new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
  const sized = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const niceTitle = (t) => String(t).replace(/^(.*) in ([^]+)$/, '$1 - $2');

  /* ---------- Rendering ---------- */
  const renderItems = () => {
    const currency = cart.currency;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="sv-cart__empty"><p>Your cart is empty</p><a href="/collections/all">Continue shopping</a></div>';
      footEl.hidden = true;
    } else {
      itemsEl.innerHTML = cart.items.map((it) => {
        const opts = (it.options_with_values || []).filter((o) => o.value !== 'Default Title').map((o) => esc(o.value)).join(' / ');
        return (
          '<div class="sv-cart__item" data-key="' + esc(it.key) + '">' +
            '<a class="sv-cart__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 300)) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a>' +
            '<div class="sv-cart__info">' +
              '<a class="sv-cart__name" href="' + esc(it.url) + '" title="' + esc(it.product_title) + '">' + esc(niceTitle(it.product_title)) + '</a>' +
              (opts ? '<div class="sv-cart__meta">' + opts + '</div>' : '') +
              '<div class="sv-cart__price">' +
                (it.final_line_price < it.original_line_price
                  ? '<s>' + money(it.original_line_price, currency) + '</s><span class="is-sale">' + money(it.final_line_price, currency) + '</span>'
                  : money(it.final_line_price, currency)) +
              '</div>' +
              (it.line_level_discount_allocations || []).map((d) => (
                '<div class="sv-cart__disc">' + esc(d.discount_application && d.discount_application.title) + ' (&minus;' + money(d.amount, currency) + ')</div>'
              )).join('') +
              '<div class="sv-cart__row">' +
                '<div class="sv-qty">' +
                  '<button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="sv-cart__remove" data-qty="0">Remove</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');
      footEl.hidden = false;
    }
    totalEl.textContent = money(cart.total_price, currency) + ' ' + currency;
    updateBubbles();
    renderOffer();
  };

  /* ---------- "Buy 2+, save 15%" offer ---------- */
  const OFFER_TAG = 'offer-buy2';
  const OFFER_URL = '/collections/offer-buy-2';
  const offerEl = root.querySelector('[data-sv-offer]');
  const tagsByHandle = new Map();

  const productTags = (handle) => {
    if (!tagsByHandle.has(handle)) {
      tagsByHandle.set(handle, fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then((r) => (r.ok ? r.json() : { tags: [] }))
        .then((p) => p.tags || [])
        .catch(() => []));
    }
    return tagsByHandle.get(handle);
  };

  const renderOffer = async () => {
    const snapshot = cart;
    const tags = await Promise.all(snapshot.items.map((it) => productTags(it.handle)));
    if (snapshot !== cart) return; // a newer cart render is on its way
    const units = snapshot.items.reduce((n, it, i) => n + (tags[i].includes(OFFER_TAG) ? it.quantity : 0), 0);
    const saved = snapshot.items.reduce((n, it) => n + (it.line_level_discount_allocations || []).reduce((s, d) => s + d.amount, 0), 0);
    // Only claim "applied" when Shopify actually applied a discount to the cart lines
    if (units === 0 || (units > 1 && saved === 0)) {
      offerEl.hidden = true;
      return;
    }
    offerEl.innerHTML = units === 1
      ? 'Add 1 more piece to save 15%<a href="' + OFFER_URL + '">Shop the offer</a>'
      : '<strong>15% off applied</strong>' + (saved > 0 ? ' &middot; You save ' + money(saved, snapshot.currency) : '');
    offerEl.hidden = false;
  };

  const updateBubbles = () => {
    document.querySelectorAll('#cart-icon-bubble .h-count, #cart-icon-bubble-mobile .h-count, .cart-count, [data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
    });
  };

  /* ---------- Recommendations: related to the product just added, with size picker ---------- */
  const sizeLabel = (v) => (v.title === 'Default Title' ? '' : v.title);

  const recCard = (p) => {
    const variants = (p.variants || []).filter((v) => v.id);
    const single = variants.length <= 1;
    const sizes = single ? '' : (
      '<div class="sv-rec__sizes" data-rec-sizes hidden>' +
        '<span class="sv-rec__label">' + esc(p.option || 'Size') + '</span>' +
        variants.map((v) => (
          '<button type="button" class="sv-rec__size" data-rec-vid="' + v.id + '"' + (v.available ? '' : ' disabled aria-disabled="true"') + '>' + esc(sizeLabel(v)) + '</button>'
        )).join('') +
      '</div>'
    );
    const firstAvailable = variants.find((v) => v.available);
    return (
      '<div class="sv-rec" data-rec-pid="' + p.id + '">' +
        '<a class="sv-rec__link" href="' + esc(p.url) + '">' +
          '<span class="sv-rec__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</span>' +
          '<span class="sv-rec__name">' + esc(niceTitle(p.title)) + '</span>' +
          '<span class="sv-rec__price">' + money(p.price, cart && cart.currency) + ' ' + esc((cart && cart.currency) || 'USD') + '</span>' +
        '</a>' +
        '<button type="button" class="sv-rec__add" ' + (single ? 'data-rec-vid="' + (firstAvailable ? firstAvailable.id : '') + '"' : 'data-rec-toggle') + ' aria-expanded="false">+ Add</button>' +
        sizes +
        '<span class="sv-rec__done" data-rec-done hidden>Added &#10003;</span>' +
      '</div>'
    );
  };

  const renderRecs = () => {
    const inCart = new Set(cart ? cart.items.map((i) => i.product_id) : []);
    const list = recs.filter((p) => !inCart.has(p.id)).slice(0, 10);
    const html = list.map(recCard).join('');
    recsLists.forEach((el) => (el.innerHTML = html));
    const has = list.length > 0;
    recsSide.hidden = !has;
    recsStrip.hidden = !has;
  };

  let recsCssAdded = false;
  const fetchRelated = async (handle) => {
    try {
      const res = await fetch('/products/' + encodeURIComponent(handle) + '?section_id=seravonti-cart-recs');
      if (!res.ok) return [];
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const css = doc.querySelector('style[data-sv-recs-css]');
      if (css && !recsCssAdded) { document.head.appendChild(css); recsCssAdded = true; }
      const data = doc.querySelector('script[data-sv-recs]');
      return data ? JSON.parse(data.textContent) : [];
    } catch (e) { return []; }
  };

  // Fallback: Shopify's own recommendations, mapped to the same shape
  const fetchShopifyRecs = async (productId) => {
    try {
      const res = await fetch(recsBase + '.json?product_id=' + productId + '&limit=10&intent=related');
      if (!res.ok) return [];
      const data = await res.json();
      return (data.products || []).filter((p) => p.available).map((p) => ({
        id: p.id, handle: p.handle, title: p.title, url: p.url, price: p.price,
        image: sized(p.featured_image, 360),
        option: (p.options && p.options[0] && (p.options[0].name || p.options[0])) || 'Size',
        variants: (p.variants || []).map((v) => ({ id: v.id, title: v.title, available: v.available }))
      }));
    } catch (e) { return []; }
  };

  const loadRecs = async () => {
    if (!cart.items.length) { recs = []; renderRecs(); return; }
    const anchor = cart.items.find((i) => i.product_id === lastProductId) || cart.items[0];
    if (recsFor === anchor.product_id) { renderRecs(); return; }
    recsFor = anchor.product_id;
    let list = await fetchRelated(anchor.handle);
    if (!list.length) list = await fetchShopifyRecs(anchor.product_id);
    if (recsFor !== anchor.product_id) return; // a newer request replaced this one
    recs = list;
    renderRecs();
  };

  const addFromRec = async (card, variantId) => {
    if (!variantId) return;
    card.classList.add('is-busy');
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-SV': '1' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    });
    card.classList.remove('is-busy');
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      alert(data.description || data.message || 'Could not add this item');
      return;
    }
    const done = card.querySelector('[data-rec-done]');
    if (done) done.hidden = false;
    await refresh();
    setTimeout(renderRecs, 900); // let "Added" show, then drop the item from the list
  };

  root.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-rec-toggle]');
    if (toggle) {
      const card = toggle.closest('[data-rec-pid]');
      const sizes = card.querySelector('[data-rec-sizes]');
      const openNow = sizes.hidden;
      root.querySelectorAll('.sv-rec.is-open').forEach((c) => {
        c.classList.remove('is-open');
        c.querySelector('[data-rec-sizes]').hidden = true;
        c.querySelector('[data-rec-toggle]').setAttribute('aria-expanded', 'false');
      });
      sizes.hidden = !openNow;
      card.classList.toggle('is-open', openNow);
      toggle.setAttribute('aria-expanded', String(openNow));
      return;
    }
    const pick = e.target.closest('[data-rec-vid]');
    if (pick && !pick.disabled) addFromRec(pick.closest('[data-rec-pid]'), pick.dataset.recVid);
  });

  /* ---------- Data ---------- */
  const refresh = async () => {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    cart = await res.json();
    renderItems();
    return cart;
  };

  const change = async (key, quantity) => {
    const row = itemsEl.querySelector('[data-key="' + CSS.escape(key) + '"]');
    if (row) row.classList.add('is-busy');
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
    });
    if (res.ok) {
      cart = await res.json();
      renderItems();
      loadRecs();
    } else {
      const data = await res.json().catch(() => ({}));
      if (row) row.classList.remove('is-busy');
      alert(data.description || data.message || 'Could not update the cart');
    }
  };

  itemsEl.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const row = btn.closest('[data-key]');
    change(row.dataset.key, Number(btn.dataset.qty));
  });

  /* ---------- Open / close ---------- */
  const open = async (opts) => {
    if (opts && opts.productId) lastProductId = opts.productId;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sv-cart-lock');
    await refresh();
    loadRecs();
  };
  const close = () => {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sv-cart-lock');
  };

  root.querySelectorAll('[data-sv-cart-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
  document.addEventListener('sv:cart:open', (e) => open(e.detail || {}));

  // Cart icons and /cart links open the drawer instead of the old minicart
  document.addEventListener('click', (e) => {
    if (onCartPage) return;
    const a = e.target.closest('#cart-icon-bubble, #cart-icon-bubble-mobile, a[href="/cart"], a[href$="/cart"]');
    if (!a || root.contains(a)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // Theme add-to-cart (product cards, quick view) → close its minicart and open ours
  const html = document.documentElement;
  new MutationObserver(() => {
    if (html.classList.contains('open-minicart')) {
      html.classList.remove('open-minicart', 'open-drawer');
      document.body.style.removeProperty('overflow');
      if (!onCartPage) open();
    }
  }).observe(html, { attributes: true, attributeFilter: ['class'] });

  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = nativeFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url) && !(init && init.headers && init.headers['X-SV'])) {
      p.then((res) => {
        if (!res.ok) return;
        res.clone().json().then((d) => {
          const pid = d && (d.product_id || (d.items && d.items[0] && d.items[0].product_id));
          if (pid) lastProductId = pid;
        }).catch(() => {});
      }).catch(() => {});
    }
    return p;
  };

  window.SeravontiCart = { open, close, refresh };
})();
